import { render, staticRenderFns } from "./Achillea.vue?vue&type=template&id=009627a9&scoped=true"
import script from "./Achillea.vue?vue&type=script&lang=js"
export * from "./Achillea.vue?vue&type=script&lang=js"
import style0 from "./Achillea.vue?vue&type=style&index=0&id=009627a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009627a9",
  null
  
)

export default component.exports